import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { ApiResponse } from '@app/_models';
import { retry } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { SharedService } from '@app/_components/_shared/shared.service';

@Injectable({ providedIn: 'root' })
export class ActivityWishlistService {

	statuses: any[] = [
		{ value: 'draft',      name: 'Draft' },
		{ value: 'submitted',  name: 'Submitted' },
		{ value: 'suggested',  name: 'Suggested' },
		{ value: 'viewed',     name: 'Viewed' },
		{ value: 'confirmed',  name: 'Confirmed' },
		{ value: 'processing', name: 'Processing' },
		{ value: 'completed',  name: 'Completed' },
	];

	readonly urlEndpoint = 'activity-wishlists';

	constructor(private http: HttpClient, private sharedService: SharedService) {}

	findByFilter(page: any, size: any, sortBy: any, sortOrder: any, multiSortMeta: any, globalFilter: any, filters: any): Observable<ApiResponse> {
		const params = this.sharedService.prepareParamsFromPrimeNgDataTable(page, size, sortBy, sortOrder, multiSortMeta, globalFilter, filters);
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params }).pipe(retry({ count: 2, delay: 1500 }));
	}

	findById(id: number): Observable<ApiResponse> {
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`).pipe(retry({ count: 2, delay: 1500 }));
	}

	update(wishlist: any): Observable<ApiResponse> {
		return this.http.patch<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, wishlist);
	}

	/** Alias for activities-manager compatibility */
	findAll(params?: { status?: string; page?: number; size?: number }): Observable<ApiResponse> {
		let httpParams = this.sharedService.prepareParamsFromPrimeNgDataTable(
			params?.page ?? 0, params?.size ?? 200, null, null, null, null, null
		);
		if (params?.status) { httpParams = httpParams.set('status', params.status); }
		return this.http.get<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, { params: httpParams }).pipe(retry({ count: 2, delay: 1500 }));
	}

	/** Alias for activities-manager compatibility */
	create(data: any): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}`, data);
	}

	/** Alias for activities-manager compatibility */
	sendToGuest(id: number): Observable<ApiResponse> {
		return this.sendSuggestion(id);
	}

	sendSuggestion(id: number): Observable<ApiResponse> {
		return this.http.post<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}/send`, {});
	}

	delete(id: number): Observable<ApiResponse> {
		return this.http.delete<ApiResponse>(`${environment.apiUrl}/${this.urlEndpoint}/${id}`);
	}
}
